module.exports = __webpack_public_path__ + "static/media/img2.47488d81.jpg";